module.exports = __webpack_public_path__ + "img/annotation-newparagraph.bb7062f1.svg";